import { Smile9UserSettings } from './../../share/authenticate/auth-if';
import { PipeTransform, Pipe } from '@angular/core';

@Pipe({
  name: 'isSetSmile9UserSettingsPipe'
})
export class IsSetSmile9UserSettingsPipe implements PipeTransform {
  transform(value: Smile9UserSettings[], expectedItem: string, expectedValue: string = '1'): boolean {
    return value.some(opt => opt.item === expectedItem && opt.value === expectedValue);
  }
}
